"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _mobxReact = require("mobx-react");

var _ = require("../..");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./ContentExpander.css");

var _styles = {
  "expander": "ContentExpander__expander___1JvId",
  "header": "ContentExpander__header___2JzUo",
  "indicator": "ContentExpander__indicator___3HqhU",
  "bar-1": "ContentExpander__bar-1___2BtFC",
  "bar-2": "ContentExpander__bar-2___2_Wzt",
  "expanded": "ContentExpander__expanded___2hiXB",
  "content": "ContentExpander__content___2Ol33"
};

const styles = _bind.default.bind(_styles);

const ContentExpander = (0, _mobxReact.observer)(({
  className,
  dataTestId,
  title,
  expand,
  children
}) => {
  const composed_classname = (0, _bind.default)(styles('expander'), className);
  const [realExpanded, setRealExpanded] = (0, _react.useState)(!!expand);
  (0, _react.useEffect)(() => {
    if (expand !== undefined) {
      setRealExpanded(expand);
    }
  }, [expand]);
  return _react.default.createElement("div", {
    "data-testid": dataTestId,
    className: composed_classname
  }, _react.default.createElement("div", {
    className: styles('header'),
    onClick: () => setRealExpanded(!realExpanded)
  }, _react.default.createElement(_.Text, {
    variant: 'medium',
    text: title,
    dataTestId: dataTestId && `${dataTestId}-title`
  }), _react.default.createElement("div", {
    className: styles('indicator', {
      expanded: realExpanded
    })
  }, _react.default.createElement("div", {
    className: styles('bar-1')
  }), _react.default.createElement("div", {
    className: styles('bar-2')
  }))), _react.default.createElement(_.Expandable, {
    expand: realExpanded
  }, _react.default.createElement("div", {
    className: styles('content'),
    "data-testid": dataTestId && `${dataTestId}-content`
  }, children)));
});
var _default = ContentExpander;
exports.default = _default;